import { useNavigate } from "react-router";
import Button from "@mui/material/Button";

export default function PageNotFound() {
    const navigate = useNavigate();
    return (
        <div>
            <h1>Page non trouvée</h1>
            <Button
                onClick={() => {
                    navigate("/");
                }}>
                Aller au formulaire
            </Button>
        </div>
    );
}
